
import { LitElement, css } from 'lit';
//import { getTwSheet } from '../styles/tw-sheet.js';
//import { ensureScriptsFromManifest } from "../shared/scriptsr-loader.js";
export class SadvancedLitElement extends LitElement {
  static styles = css`
    :host {
      display: block;
    }
  `;
  async connectedCallback() {
   // await ensureScriptsFromManifest(); // guarantee vendor files are ready once
    super.connectedCallback();
  }
  createRenderRoot() {
    const root = this;//super.createRenderRoot();
    // if (root.adoptedStyleSheets) {
    //   root.adoptedStyleSheets = [...root.adoptedStyleSheets, getTwSheet()];
    // } else {
    //   const tag = document.createElement("style");
    //   import("../generated/tw.css").then((m) => (tag.textContent = m.default));
    //   root.appendChild(tag);
    // }
    return root; 
  }
}
